import { render, staticRenderFns } from "./portal.component.vue?vue&type=template&id=0734286e&"
import script from "./portal.component.vue?vue&type=script&lang=js&"
export * from "./portal.component.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports